<template>
  <div>
    <Form
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      :label-width="120"
    >
    <FormItem label="文案" prop="org_text">
        <Input v-model="formValidate.org_text" type="textarea"  placeholder="请填写文案"></Input>
      </FormItem>

      <FormItem label="翻译后文案" prop="translate_text">
        <Input v-model="formValidate.translate_text" type="textarea"  placeholder="请填写文案"></Input>
      </FormItem>

      <FormItem label="视频标题" prop="org_video_title">
        <Input v-model="formValidate.org_video_title" placeholder="请填写视频标题"></Input>
      </FormItem>

      <FormItem label="翻译后视频标题" prop="translate_video_title">
        <Input v-model="formValidate.translate_video_title" placeholder="请填写视频标题"></Input>
      </FormItem>

      <FormItem label="视频简介" prop="org_video_desc">
        <Input v-model="formValidate.org_video_desc" type="textarea" placeholder="请填写视频简介"></Input>
      </FormItem>

      <FormItem label="翻译后视频简介" prop="translate_video_desc">
        <Input v-model="formValidate.translate_video_desc" type="textarea" placeholder="请填写视频简介"></Input>
      </FormItem>

      <FormItem label="字幕文件" prop="org_srt_path">
          <input type="file" accept=".srt"  @change="handleSrtFileChange"/>
          <label class="search-label">{{show_org_srt_path}}</label>
      </FormItem>

      <FormItem label="翻译后字幕文件" prop="translate_srt_path">
          <input type="file" accept=".srt"  @change="handleTranslateSrtFileChange"/>
          <label class="search-label">{{show_translate_srt_path}}</label>
      </FormItem>

      <template v-for="(item, index) in formValidate.goodItems">
          <FormItem
                  :label="'金句评论' + (index + 1)">
              <Row>
                  <Col span="18">
                      <Input type="text" v-model="item.value" placeholder="请填写"></Input>
                  </Col>
                  <Col span="4" offset="1">
                      <Button @click="handleGoodCommentRemove(index)">删除</Button>
                  </Col>
              </Row>
          </FormItem>

          <FormItem
                  :label="'翻译后金句评论' + (index + 1)">
              <Row>
                  <Col span="18">
                      <Input type="text" v-model="item.translate_value" placeholder="请填写"></Input>
                  </Col>
                  <Col span="4" offset="1">
                  </Col>
              </Row>
          </FormItem>

        </template>

      <FormItem>
          <Row>
              <Col span="12">
                  <Button type="dashed" long @click="handleGoodAdd" icon="md-add">添加</Button>
              </Col>
          </Row>
      </FormItem>

        <template v-for="(item, index) in formValidate.blackItems">
          <FormItem
                  :label="'黑粉评论' + (index + 1)">
              <Row>
                  <Col span="18">
                      <Input type="text" v-model="item.value" placeholder="请填写"></Input>
                  </Col>
                  <Col span="4" offset="1">
                      <Button @click="handleBlackCommentRemove(index)">删除</Button>
                  </Col>
              </Row>
          </FormItem>

          <FormItem
                  :label="'翻译后黑粉评论' + (index + 1)">
              <Row>
                  <Col span="18">
                      <Input type="text" v-model="item.translate_value" placeholder="请填写"></Input>
                  </Col>
                  <Col span="4" offset="1">
                  </Col>
              </Row>
          </FormItem>
        </template>

        <FormItem>
            <Row>
                <Col span="12">
                    <Button type="dashed" long @click="handleBlackAdd" icon="md-add">添加</Button>
                </Col>
            </Row>
        </FormItem>

      <FormItem style="text-align: right">
        <Button @click="handleReset('formValidate')">重置</Button>
        <Button
          type="primary"
          @click="handleSubmit('formValidate')"
          style="margin-left: 8px"
          >提交</Button
        >
      </FormItem>
    </Form>
  </div>
</template>

<script>
import params from '../argu-page/params.vue'
import moment from 'moment'
import { getOssClient } from '@/api/ossClient'

// Vue.directive('file-model', {
//   bind(el, binding, vnode) {
//     el.addEventListener('change', () => {
//       if (el.files.length) {
//         vnode.context[binding.value] = el.files[0];
//       }
//     });
//   }
// });

export default {
  components: { params },
  props: {
    resetFlag: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: () => {}
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      userIds: [],
      workTypeIds: [],
      shortVideoClassifyIds: [],
      show_org_srt_path: '',
      show_translate_srt_path: '',
      formValidate: {
        id: '',
        org_text: '',
        translate_text: '',
        org_video_title: '',
        translate_video_title: '',
        org_video_desc: '',
        translate_video_desc: '',
        org_srt_path: '',
        translate_srt_path: '',
        blackItems: [],
        goodItems: []
      },
      ruleValidate: {
      }
    }
  },
  watch: {
    resetFlag (resetFlag) {
      this.handleReset('formValidate')
    }
  },
  methods: {
    setEditData (params) {
      this.formValidate.id = params.id.toString()
      this.formValidate.org_text = params.org_text
      this.formValidate.translate_text = params.translate_text
      this.formValidate.org_video_title = params.org_video_title
      this.formValidate.translate_video_title = params.translate_video_title
      this.formValidate.org_video_desc = params.org_video_desc
      this.formValidate.translate_video_desc = params.translate_video_desc
      this.formValidate.org_srt_path = params.org_srt_path
      this.formValidate.translate_srt_path = params.translate_srt_path

      if (params.org_srt_path != null) {
        var org_srt_path_array = params.org_srt_path.split('/')
        this.show_org_srt_path = org_srt_path_array[org_srt_path_array.length - 1]
      }

      if (params.translate_srt_path != null) {
        var org_translate_path_array = params.translate_srt_path.split('/')
        this.show_translate_srt_path = org_translate_path_array[org_translate_path_array.length - 1]
      }

      this.formValidate.goodItems = JSON.parse(params.good_comment)
      this.formValidate.blackItems = JSON.parse(params.black_comment)
    },
    handleGoodAdd () {
      this.formValidate.goodItems.push({ 'value': '', 'translate_value': '' })
    },
    handleBlackAdd () {
      this.formValidate.blackItems.push({ 'value': '', 'translate_value': '' })
    },
    handleGoodCommentRemove (index) {
      this.formValidate.goodItems.splice(index, 1)
    },
    handleBlackCommentRemove (index) {
      this.formValidate.blackItems.splice(index, 1)
    },
    async handleSrtFileChange (e) {
      const file = e.target.files[0]
      if (!file) return

      try {
        let currentDate = moment().format('YYYY-MM-DD')
        // 上传文件
        const client = await getOssClient()
        const result = await client.put('short_video/' + currentDate + '/check_srt_task/' + file.name, file)
        if (result['res']['statusCode'] == 200) {
          this.formValidate.org_srt_path = result['res']['requestUrls'][0]

          if (this.formValidate.org_srt_path != null) {
            var org_srt_path_array = this.formValidate.org_srt_path.split('/')
            this.show_org_srt_path = org_srt_path_array[org_srt_path_array.length - 1]
          }

          this.$Message.info('上传成功')
        } else {
          this.$Message.error('上传失败')
        }
      } catch (error) {
        this.$Message.error('上传失败')
      }
    },
    async handleTranslateSrtFileChange (e) {
      const file = e.target.files[0]
      if (!file) return

      try {
        let currentDate = moment().format('YYYY-MM-DD')
        // 上传文件
        var name = file.name.substring(file.name.lastIndexOf('.'))
        const client = await getOssClient()
        const result = await client.put('short_video/' + currentDate + '/check_srt_task/' + name, file)
        if (result['res']['statusCode'] == 200) {
          this.formValidate.translate_srt_path = result['res']['requestUrls'][0]

          if (this.formValidate.translate_srt_path != null) {
            var translate_srt_path_array = this.formValidate.translate_srt_path.split('/')
            this.show_translate_srt_path = translate_srt_path_array[translate_srt_path_array.length - 1]
          }
          this.$Message.info('上传成功')
        } else {
          this.$Message.error('上传失败')
        }
      } catch (error) {
        this.$Message.error('上传失败')
      }
    },
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$emit('on-ok', this.formValidate)
        } else {
          this.$Message.error('失败!')
        }
      })
    },
    handleReset (name) {
      this.$refs[name].resetFields()
    }
  }
}
</script>
